// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f43eb6b7","226":"ad96071b","328":"984905cf","520":"3b71f71a","570":"277c4ccf","625":"187e883b","703":"fb856681","705":"5c6ea40b","859":"8102bd2a"}[chunkId] + ".chunk.js";
};